import { DeleteAccountGroupsApi } from "@/features/accounts/account-group/services/delete-account-groups-api";
import { DeleteAccountGroupsRequestModel } from "@/features/accounts/account-group/services/delete-account-groups-model";

/// 口座グループ削除
export class DeleteAccountGroupsService {
  private deleteAccountGroupsApi = new DeleteAccountGroupsApi();

  /**
   * 口座グループ削除
   */
  public async deleteAccountGroups(param: DeleteAccountGroupsRequestModel) {
    return await this.deleteAccountGroupsApi.deleteAccountGroup(param);
  }
}

